var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacegreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 6H10.0063M5.99967 6H6.00634M14.6663 8C14.6663 11.6819 11.6816 14.6667 7.99967 14.6667C4.31778 14.6667 1.33301 11.6819 1.33301 8C1.33301 4.3181 4.31778 1.33333 7.99967 1.33333C11.6816 1.33333 14.6663 4.3181 14.6663 8ZM10.333 6C10.333 6.18409 10.1838 6.33333 9.99967 6.33333C9.81558 6.33333 9.66634 6.18409 9.66634 6C9.66634 5.8159 9.81558 5.66666 9.99967 5.66666C10.1838 5.66666 10.333 5.8159 10.333 6ZM6.33301 6C6.33301 6.18409 6.18377 6.33333 5.99967 6.33333C5.81558 6.33333 5.66634 6.18409 5.66634 6C5.66634 5.8159 5.81558 5.66666 5.99967 5.66666C6.18377 5.66666 6.33301 5.8159 6.33301 6ZM7.99967 11.6667C9.66667 11.6667 10.9997 10.4447 10.9997 9.33333H4.99967C4.99967 10.4447 6.33267 11.6667 7.99967 11.6667Z",
    stroke: "#17B26A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacegreen);
export default __webpack_public_path__ + "static/media/facegreen.ee6a882feda65ecff23c3075fe3dd6a1.svg";
export { ForwardRef as ReactComponent };